export default __webpack_public_path__ + "static/media/iphone.84bfaaa3.png";